import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { logger } from '../common';

type SurfaceAttributes = {
	principalEntityId: string;
	principalEntityType: string;
	relatedTopics: string[];
	location: string;
	sessionId?: string;
	searchQuery?: string;
};

export const onSurfaceShown = (surfaceAttributes: SurfaceAttributes): AnalyticsEventPayload => {
	try {
		return {
			action: 'shown',
			actionSubjectId: 'aiTopic',
			actionSubject: 'surface',
			eventType: 'track',
			attributes: {
				...surfaceAttributes,
			},
		};
	} catch (error) {
		logger.error({ error, functionName: 'onSurfaceShown' });
		return {};
	}
};

type EntityClickAttributes = {
	clickedEntityId: string;
	clickedEntityType: string;
	principalEntityId: string;
	principalEntityType: string;
	sessionId?: string;
	location: string;
	position?: number;
	shownAfterCardBodyExpanded?: boolean;
};

export const onRelatedEntityClick = (
	entityClickAttributes: EntityClickAttributes,
): AnalyticsEventPayload => {
	try {
		return {
			action: 'clicked',
			actionSubjectId: 'aiTopic',
			actionSubject: 'relatedEntity',
			eventType: 'ui',
			attributes: {
				...entityClickAttributes,
			},
		};
	} catch (error) {
		logger.error({ error, functionName: 'onRelatedEntityClick' });
		return {};
	}
};

export const onSentimentClick = (
	sentimentClickAttributes: Record<string, string>,
): AnalyticsEventPayload => {
	try {
		return {
			action: 'clicked',
			actionSubjectId: 'aiTopic',
			actionSubject:
				sentimentClickAttributes.sentiment === 'positive' ? 'likeButton' : 'dislikeButton',
			eventType: 'ui',
			attributes: {
				...sentimentClickAttributes,
			},
		};
	} catch (error) {
		logger.error({ error, functionName: 'onSentimentClick' });
		return {};
	}
};

type ToggleMoreRelatedEntitiesClickedAttributes = {
	sessionId?: string;
	location: string;
	expanded: boolean;
};

export const onToggleMoreRelatedEntitiesClick = (
	showMoreRelatedEntitiesClickedAttributes: ToggleMoreRelatedEntitiesClickedAttributes,
): AnalyticsEventPayload => {
	return {
		action: 'clicked',
		actionSubjectId: 'aiTopic',
		actionSubject: 'toggleMoreRelatedEntities',
		eventType: 'ui',
		attributes: {
			...showMoreRelatedEntitiesClickedAttributes,
		},
	};
};
